import VideoCard, { VideoCardComponent } from './VideoCard';

export { VideoCardComponent };
export default VideoCard;
